import axios from '../utils/axios';

export default function uploadInvoices(adminId, data) {
    return (
        axios.post(`/admin/${adminId}/upload-transactions`, data)
    )
}
